import api from '@/script/api.js'

export default {
  async getUsersMe({ commit }) {
    const res = await api.getUsersMe()
    if (res.status === 200) {
      commit('UPDATE_USER_DETAILS', res.data)
    }
    return res
  },

  async getUsersModels({ commit }, userId) {
    const res = await api.getUsersModels(userId)

    if (res.status === 200) {
      commit('UPDATE_USER_MODELS', res.data)
    }

    return res
  }
}
